import React from 'react';
import { EmailCollectionModal } from '@/components/auth/EmailCollectionModal';
import { useEmailCollection } from '@/hooks/useEmailCollection';

export const EmailCollectionProvider: React.FC = () => {
  const { needsEmailCollection, isLoading, markEmailCollected, skipEmailCollection } =
    useEmailCollection();

  if (isLoading) {
    return null;
  }

  return (
    <EmailCollectionModal
      isOpen={needsEmailCollection}
      onClose={skipEmailCollection}
      onComplete={markEmailCollected}
      title="Complete Your Profile"
      description="Add your email address to unlock these benefits:"
      benefits={[
        "Order confirmations and receipts in your inbox",
        "Important shipping and delivery notifications",
        "Exclusive deals and promotional offers",
        "Direct customer support communication",
        "Account security and update notifications"
      ]}
      showBenefits={true}
      useGradientStyling={true}
      skipOption={{
        text: "I'll add it later",
        subtext: "You can always add your email address from your profile settings"
      }}
    />
  );
};